
import { AuthorProfileModel } from '../models/AuthorProfileModel.js';
import { AuthorProfileView } from '../views/AuthorProfileView.js';

export class AuthorProfileController {
    constructor() {

        this.model = new AuthorProfileModel();
        this.view = new AuthorProfileView();

        this.model.subscribe(state => this.view.render(state));
    }
}